// Government.js
import React, { useState, useEffect, useRef } from "react";
import { useAuth } from "../AuthContext";
import "../styles/LogInsert.css";


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const LogInsert = () => {
    const { user, setUser } = useAuth();
    const [datas, setDatas] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 15;
    //const [isModalOpen, setIsModalOpen] = useState(false); // 모달 상태 관리
    const [searchField, setSearchField] = useState("all");  // 라디오 버튼에서 선택된 항목
    const [searchField2, setSearchField2] = useState("all");  // 라디오 버튼에서 선택된 항목
    const [searchKeyword, setSearchKeyword] = useState("");  // 검색 키워드

    //const [selectedGovernment, setSelectedGovernment] = useState(null);

    const [plist, setPlist] = useState([]);
    const [glist, setGlist] = useState([]);
    const [LoginUserText, setLoginUserText] = useState("");

    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) return; // 이미 실행되었으면 종료
        hasRun.current = true; // 첫 실행 후 플래그 설정

        getPartnerCode();
        getGovernmentCode();

        

    }, []);

    useEffect(() => {
        if (user.userType === "S") {

            setLoginUserText(`Admin > ${user.name}`);
        }
        else if (user.userType === "P" && plist.length > 0) {
            const selectedPartner = plist.find(p => p.partnerCode === user.partnerCode);
            const partnerName = selectedPartner?.partnerName ?? "알 수 없는 파트너";
            setLoginUserText(`${partnerName} > ${user.name}`);
        }
        else if (user.userType === "G" && glist.length > 0) {
            const selectedGovernment = glist.find(p => p.governmentCode === user.governmentCode);
            const governmentName = selectedGovernment?.governmentName ?? "알 수 없는 파트너";
            setLoginUserText(`${governmentName} > ${user.name}`);
        }
        else if (user.userType === "U") {

            setLoginUserText(`${user.userId}`);
        }
        else {
            setLoginUserText(`비 정상 로그인입니다.`);
        }
    }, [plist, glist]); // plist가 업데이트될 때 실행

    // 파트너 코드 리스트 가져오기
    const getPartnerCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Partner/get-list`);
            const data = await response.json();

            if (response.ok) {
                setPlist(data.plist);
                //console.log(data.plist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("파트너 리스트 조회 중 오류가 발생했습니다.");
        }
    };

    // 파트너 코드 리스트 가져오기
    const getGovernmentCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Government/get-list`);
            const data = await response.json();

            if (response.ok) {
                setGlist(data.glist);
                //console.log(data.glist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("관공서 리스트 조회 중 오류가 발생했습니다.");
        }
    };

    //const handleRowClick = (Government) => {
    //    setSelectedGovernment(Government);
    //};

    //const handleSaveGovernment = (updatedGovernment) => {
    //    setUsers(users.map((u) => (u.snum === updatedGovernment.snum ? updatedGovernment : u)));
    //};

    const handleSearch = () => {
        fetchUsers(searchField, searchKeyword, searchField2);  // 필터링된 값으로 다시 fetch 호출
    };

    const handleSearchFieldChange = (e) => {
        const selectedValue = e.target.value;
        setSearchField(selectedValue);  // 선택된 콤보박스 값 설정
        
    };

    const handleSearchKeywordChange = (e) => {
        setSearchKeyword(e.target.value);  // 검색어 값 설정
    };

    const handleSearchFieldChange2 = (e) => {
        const selectedValue = e.target.value;
        setSearchField2(selectedValue);  // 선택된 콤보박스 값 설정        
    };

    //const handleUserTypeChange = (e) => {
    //    setSearchKeyword(e.target.value); // 선택한 값(S, P, G, U) 저장
    //};
    

    // 기존의 fetchUsers 함수에 검색 필터 추가
    const fetchUsers = async (searchField, searchKeyword, searchField2) => {
        
        try {
            const queryParams = new URLSearchParams({
                page,
                pageSize,
                searchField,
                searchKeyword,
                searchField2,
                userType: user.userType,
                userId: user.userId
            });

            const response = await fetch(`${API_BASE_URL}/api/Log/get-logdata?${queryParams}`);
            const data = await response.json();

            if (response.ok) {
                
                setDatas(data.logdatas);
                setTotalPages(Math.ceil(data.totalRecords / pageSize));
                //console.log(datas);
            } else {
                console.log(data.message || "조회 실패");
            }
        } catch (error) {
            console.error("조회 실패:", error);
            alert("서버 오류 발생");
        }
    };

    useEffect(() => {
        fetchUsers(searchField, searchKeyword, searchField2);
    }, [page]);

    useEffect(() => {
        const validTotalPages = totalPages > 0 ? totalPages : 1; // totalPages가 0 또는 null이면 1로 설정

        if (page > validTotalPages) {
            setPage(validTotalPages);  // 현재 선택된 페이지가 전체 페이지보다 크면 마지막 페이지로 이동
        }
    }, [totalPages]);  // totalPages가 변경될 때 실행

    

    const renderPagination = () => {
        if (totalPages <= 10) {
            return [...Array(totalPages)].map((_, index) => (
                <button
                    key={index + 1}
                    className={page === index + 1 ? "active" : ""}
                    onClick={() => setPage(index + 1)}
                >
                    [{index + 1}]
                </button>
            ));
        }
        let pages = [];
        if (page <= 6) {
            pages = [1, 2, 3, 4, 5, 6, 7, 8, 9, "...", totalPages];
        } else if (page >= totalPages - 5) {
            pages = [1, "...", totalPages - 8, totalPages - 7, totalPages - 6, totalPages - 5, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
        } else {
            pages = [1, "...", page - 3, page - 2, page - 1, page, page + 1, page + 2, page + 3, "...", totalPages];
        }

        return pages.map((p, index) => (
            <button
                key={index}
                className={page === p ? "active" : ""}
                onClick={() => typeof p === "number" && setPage(p)}
                disabled={typeof p !== "number"}
            >
                [{p}]
            </button>
        ));
    };

    const getContentMessage = (contents, userObject) => {
        const messages = {
            "1-1": "로그인 실패했습니다.",
            "1-2": "로그인 하였습니다.",
            "2-1": "로그아웃 하였습니다.",
            "3-1": `새로운 봉안정보를 등록했습니다. (${userObject})`,
            "3-2": `봉안정보를 수정했습니다. (${userObject})`,
            "3-3": `봉안내용 보기를 수행했습니다. (${userObject})`,
            "3-4": `봉안정보를 삭제했습니다. (${userObject})`,
            "5-1": `새로운 사용자를 등록했습니다. (${userObject})`,
            "5-2": `사용자 정보를 수정했습니다. (${userObject})`,
            "5-3": `사용자 비밀번호를 초기화했습니다. (${userObject})`,
            "5-4": `사용자 정보를 삭제했습니다. (${userObject})`,
            "6-1": `새로운 파트너 업체 정보를 등록했습니다. (${userObject})`,
            "6-2": `파트너 업체 정보를 수정했습니다. (${userObject})`,
            "6-4": `파트너 업체를 삭제했습니다. (${userObject})`,
            "6-5": `사용자 정보 중 파트너코드가 ${userObject} 건 자동수정되었습니다.`,
            "6-6": `봉안 정보 중 파트너코드가 ${userObject} 건 자동수정되었습니다.`,
            "7-1": `새로운 관할 관공서 정보를 등록했습니다. (${userObject})`,
            "7-2": `관할 관공서 정보를 수정했습니다. (${userObject})`,
            "7-4": `관할 관공서 정보를 삭제했습니다. (${userObject})`,
            "8-2": `사용자 정보 중 (${userObject}) 필드를 수정하였습니다.`,
            "8-3": "사용자가 비밀번호를 변경하였습니다."
        };

        return messages[contents] || "알 수 없는 작업을 수행했습니다.";
    };

    return (
        <div className="loginsert-wrapper">
            <div className="loginsert-header">
                
                <h1>로그정보 보기 <span style={{ fontSize: "0.7em", color: "gray" }}>{LoginUserText}</span></h1>
                                
            </div>
            <hr className="title-line" />

            {/* ✅ 모달 창 표시 (GovernmentRegisterModal.js에 handleUserAdded 전달) 
            {isModalOpen && <GovernmentRegisterModal onClose={() => setIsModalOpen(false)} onGovernmentAdded={handleGovernmentAdded} />}
            */}

            {/* 검색 섹션 */}
            <div className="search-container">
                {/* userType이 'S'일 때만 검색 필드 표시 */}
                {user?.userType === 'S' && (
                    <>
                        <label>
                            <select value={searchField} onChange={handleSearchFieldChange}>
                                <option value="all">전체조회</option>
                                <option value="userid">사용자ID</option>
                                <option value="userip">사용자IP</option>
                            </select>
                        </label>

                        {/* 검색어 입력 (전체조회 제외) */}
                        {searchField !== "all" && (
                            <label>
                                <input
                                    type="text"
                                    value={searchKeyword}
                                    onChange={handleSearchKeywordChange}
                                    maxLength={18}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleSearch();
                                        }
                                    }}
                                />
                            </label>
                        )}
                    </>
                )}

                <label>
                    <select value={searchField2} onChange={handleSearchFieldChange2}>
                        <option value="all">전체조회</option>
                        <option value="loginout">로그인/아웃</option>
                        <option value="enshrineload">봉안로딩</option>
                        <option value="itemadd">등록</option>
                        <option value="itemmodify">수정</option>
                        <option value="itemdelete">삭제</option>
                        <option value="passreset">비번초기화</option>
                        <option value="automodify">자동수정항목</option>
                        <option value="usermodify">사용자정보수정</option>
                        <option value="passchange">사용자비번변경</option>
                    </select>
                </label>

                <button onClick={handleSearch}>검색</button>
            </div>

            <div className="loginsert-container">
                <ul className="loginsert-list">
                    <li className="loginsert-header-row">
                        <span className="snum">순번</span>
                        <span className="userID">사용자ID</span>
                        <span className="dateTime">기록일시</span>
                        <span className="contents">내용</span>
                        <span className="userIP">사용자IP</span>
                    </li>
                    <hr className="thick-line" />

                    {datas.map((datas, index) => (
                        <React.Fragment key={datas.snum}>
                            <li className="loginsert-row" >
                                <span className="snum">{datas.snum}</span>
                                <span className="userID">{datas.userID}</span>
                                <span className="dateTime">{datas.dateTime}</span>                                
                                <span className="contents">{getContentMessage(datas.contents, datas.userObject)}</span>
                                <span className="userIP">{datas.userIP}</span>  
                            </li>
                            <hr className="thin-line" /> 
                        </React.Fragment>
                    ))}

                    {/*
                    {selectedGovernment && <GovernmentEditModal selectedGovernment={selectedGovernment} onClose={() => setSelectedGovernment(null)} onSave={handleSaveGovernment} onGovernmentAdded={handleGovernmentAdded} />}
                    */}

                    <hr className="thick-line" />
                </ul>
                <div className="pagination">{renderPagination()}</div>
            </div>

        </div>



    );
};

export default LogInsert;